import type { ChatEvent } from "../../types/index.ts";

/** Where the next build stands. The built preview itself comes from the server. */
export type PreviewState = { kind: "idle" } | { kind: "building" } | { kind: "failed"; message: string };

export type PreviewEvent = Extract<ChatEvent, { type: "preview" }>;

export function previewStateFrom(event: PreviewEvent): PreviewState {
  if (event.status === "building") return { kind: "building" };
  if (event.status === "failed") {
    return { kind: "failed", message: event.message ?? "Förhandsvisningen gick inte att bygga." };
  }
  return { kind: "idle" };
}

/** "Uppdaterad 14:32", or with the date when it was not today. */
export function builtText(builtAt: string, now = new Date()): string {
  const at = new Date(builtAt);
  if (Number.isNaN(at.getTime())) return "Uppdaterad";
  const time = at.toLocaleTimeString("sv-SE", { hour: "2-digit", minute: "2-digit" });
  if (at.toDateString() === now.toDateString()) return `Uppdaterad ${time}`;
  return `Uppdaterad ${at.toLocaleDateString("sv-SE", { day: "numeric", month: "short" })} ${time}`;
}
